/* global axios */
import WhatsAppSipApiClient from './index';

class WhatsAppSipTrunksAPI extends WhatsAppSipApiClient {
  constructor() {
    super('sip_trunks');
  }

  get() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${encodeURIComponent(id)}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.put(`${this.url}/${encodeURIComponent(id)}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${encodeURIComponent(id)}`);
  }

  fetchSipCredentials(inboxId) {
    return axios.post(`${this.url}/fetch_sip_credentials`, { inbox_id: inboxId });
  }
}

export default new WhatsAppSipTrunksAPI();
